import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import PopoverBtn from "../../popoverBtn";

export default function ButtonStep2({ children, popoverText, ...params }) {
  return (
    <Row className="align-items-center flex-nowrap position-relative mb-3">
      <Col xs={12} md={11} className="select_category">
        <Button {...params}>{children}</Button>
      </Col>

      <div className="position-absolute top-0 end-0 mt-3 w-auto me-3">
        <PopoverBtn text={""} />
      </div>
    </Row>
  );
}
